import * as React from 'react';

export const TagIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.47919 4.43326C3.17237 4.74006 3 5.15617 3 5.59004V8.95572C3.00009 9.38957 3.17252 9.80561 3.47937 10.1123L7.8422 14.4748C7.99413 14.6268 8.1745 14.7473 8.37302 14.8295C8.57153 14.9118 8.7843 14.9541 8.99917 14.9541C9.21405 14.9541 9.42682 14.9118 9.62533 14.8295C9.82385 14.7473 10.0042 14.6268 10.1561 14.4748L13.521 11.1092C13.8277 10.8024 14 10.3864 14 9.95256C14 9.51876 13.8277 9.10273 13.521 8.79595L9.15815 4.43343C8.85153 4.12675 8.43568 3.95434 8.00199 3.9541H4.63606C4.20215 3.9541 3.78601 4.12646 3.47919 4.43326ZM6 7.9541C6.55228 7.9541 7 7.50639 7 6.9541C7 6.40182 6.55228 5.9541 6 5.9541C5.44772 5.9541 5 6.40182 5 6.9541C5 7.50639 5.44772 7.9541 6 7.9541Z"
            fill="url(#paint0_linear_2941_6131)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_2941_6131"
                x1="8.5"
                y1="3.9541"
                x2="8.5"
                y2="14.9541"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FF1D1D" />
                <stop offset="1" stopColor="#FFC267" />
            </linearGradient>
        </defs>
    </svg>
);
